import Vue from 'vue';
import {HTTP} from '../../services/api-service.js';
import commonObj from '../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const shoppingCartStore = {
    namespaced: true,
    state:{
        current_cart: [],
        numberOfItemsInCart: 0,
        showPopup: false,
        totalCost: 0,
        addr: ""
    },
    getters:{
        numberOfItemsInCart: state => {
            return state.numberOfItemsInCart;
        },
        itemsInCart: state => {
            return state.current_cart;
        }
    },
    mutations: {
        updateAddr(state, addr){
            state.addr = addr;
        },
        refreshItemsInCart(state){
            var itemsInLocalStorage = common.getClientItemsInCart();
            if(itemsInLocalStorage != null && !state.current_cart.length){
                state.current_cart = itemsInLocalStorage;
            }
            else{
                if(itemsInLocalStorage == null && state.current_cart.length){
                    common.setClientItemsInCart(state.current_cart);
                }

                if(itemsInLocalStorage != null && state.current_cart.length){
                    common.removeClientItemsInCart();
                    common.setClientItemsInCart(state.current_cart);
                }
            }

            // Calculate total items in cart
            var total = 0;
            state.current_cart.forEach(item => total += item.quantity);
            state.numberOfItemsInCart = total;

            // Calculate total cost in cart
            var total_cost = 0;
            state.current_cart.forEach(item => total_cost += item.sub_total);
            state.totalCost = total_cost;
        },
        addProduct(state, obj) {
            // obj => { id: 1, quantity: 15, name: "Test", price: 123, image_path: "", UOM: "" }
            var index = state.current_cart.findIndex((item) => { return item.id == obj.id })
            if(index != -1){
                state.current_cart[index].quantity += obj.quantity;
                state.current_cart[index].sub_total = state.current_cart[index].quantity * state.current_cart[index].price;
            }
            else{
                obj.sub_total = obj.price * obj.quantity;
                state.current_cart.push(obj);
            }
            common.removeClientItemsInCart();
            common.setClientItemsInCart(state.current_cart);

            // Calculate total items in cart
            var total = 0;
            state.current_cart.forEach(item => total += item.quantity);
            state.numberOfItemsInCart = total;

            // Calculate total cost in cart
            var total_cost = 0;
            state.current_cart.forEach(item => total_cost += item.sub_total);
            state.totalCost = total_cost;
        },
        removeProduct(state, obj){
            var index = state.current_cart.findIndex((item) => { return item.id == obj.id })
            if(index != -1){
                if(state.current_cart[index].quantity - obj.quantity <= 0){
                    state.current_cart[index].quantity = 1;
                }
                else{
                    state.current_cart[index].quantity -= obj.quantity;
                }
                state.current_cart[index].sub_total = state.current_cart[index].quantity * state.current_cart[index].price;
            }
            common.removeClientItemsInCart();
            common.setClientItemsInCart(state.current_cart);

            // Calculate total items in cart
            var total = 0;
            state.current_cart.forEach(item => total += item.quantity);
            state.numberOfItemsInCart = total;

            // Calculate total cost in cart
            var total_cost = 0;
            state.current_cart.forEach(item => total_cost += item.sub_total);
            state.totalCost = total_cost;
        },
        deleteProduct(state, obj){

            Vue.set(state, 'current_cart', state.current_cart.filter(item => {return item.id != obj.id}));

            common.removeClientItemsInCart();
            common.setClientItemsInCart(state.current_cart);

            // Calculate total items in cart
            var total = 0;
            state.current_cart.forEach(item => total += item.quantity);
            state.numberOfItemsInCart = total;

            // Calculate total cost in cart
            var total_cost = 0;
            state.current_cart.forEach(item => total_cost += item.sub_total);
            state.totalCost = total_cost;

        },
        updateProductQuantity(state, obj){
            var index = state.current_cart.findIndex((item) => { return item.id == obj.id })
            if(index != -1){
                state.current_cart[index].quantity = obj.quantity;
                state.current_cart[index].sub_total = state.current_cart[index].quantity * state.current_cart[index].price;
            }
            else{
                obj.sub_total = obj.price * obj.quantity;
                state.current_cart.push(obj);
            }
            common.removeClientItemsInCart();
            common.setClientItemsInCart(state.current_cart);

            // Calculate total items in cart
            var total = 0;
            state.current_cart.forEach(item => total += item.quantity);
            state.numberOfItemsInCart = total;

            // Calculate total cost in cart
            var total_cost = 0;
            state.current_cart.forEach(item => total_cost += item.sub_total);
            state.totalCost = total_cost;
        },
        updateProductPrice(state, obj){
            // console.log('updateProductPrice')
            var index = state.current_cart.findIndex((item) => { return item.id == obj.id })
            if(index != -1){
                state.current_cart[index].price = obj.price;
                state.current_cart[index].sub_total = state.current_cart[index].quantity * state.current_cart[index].price;
            }

            common.removeClientItemsInCart();
            common.setClientItemsInCart(state.current_cart);

            // Calculate total items in cart
            var total = 0;
            state.current_cart.forEach(item => total += item.quantity);
            state.numberOfItemsInCart = total;

            // Calculate total cost in cart
            var total_cost = 0;
            state.current_cart.forEach(item => total_cost += item.sub_total);
            state.totalCost = total_cost;

        },
        toggleShoppingCart: function(state, status) {
            state.showPopup = status;
        },
        clearShoppingCart: function(state){
            state.current_cart = [];
            state.numberOfItemsInCart = 0;
            state.totalCost = 0;
            common.removeClientItemsInCart();
            common.setClientItemsInCart(state.current_cart);
        }
    },
    actions:{
        purchaseProductsInCart({commit, state}, remarks){

            var shoppingCart = [];
            state.current_cart.forEach(item =>  {
                shoppingCart.push({
                    ItemNum: item.id,
                    ItemName: item.name,
                    UnitPx: item.price,
                    Qty: item.quantity,
                    UOM: item.UOM,
                    LineAmt: item.sub_total
                })
            })


            var param = {
                scHdr:{
                    EntNum: common.getClientEntNum(),
                    EntLoc: state.addr,
                    Rem: remarks,
                    TotAmt: state.totalCost,
                    ShopCartDtl: shoppingCart
                },
                b_WebOrder: true
            }

            // console.log(param);

            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/SO/SaveShoppingCart', param).then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })

            })

        },   
    }
};
export default shoppingCartStore;